<template>
  <div id="app">
    <div class="nav-wrapper">
      <div class="nav">
        <div>
          <a :href="localizeUrl('https://www.1home.io/smart-home', $i18n.locale)">
            <img
              class="logo-image"
              src="@/assets/1home-dark-logo.png"
              alt="Logo"
            />
          </a>
        </div>
        <div class="nav-link nav-toggle" @click="toggle = !toggle">
          <font-awesome-icon v-if="!toggle" :icon="['fas', 'bars']" />
          <font-awesome-icon v-else :icon="['fas', 'times']" />
        </div>
        <nav
          class="nav-items nav-items-right"
          :class="{ 'nav-toggle-show': toggle }"
          >
<!--          <div class="nav-link">-->
<!--            <span class="nav-link-text"><a :href="localizeUrl('https://www.1home.io/smart-living', $i18n.locale)">{{$t('nav.smart-living')}}</a></span>-->
<!--          </div>-->
          <div class="nav-link">
            <span class="nav-link-text"><a :href="localizeUrl('https://www.1home.io/smart-home/book', $i18n.locale)">{{$t('nav.build-with-us')}}</a></span>
          </div>
          <div class="nav-link">
<!--          <span class="nav-link-text">-->
<!--            <LocaleChanger></LocaleChanger>-->
<!--          </span>-->
          </div>
        </nav>
      </div>
    </div>
    <transition name="fade">
      <router-view />
    </transition>
  </div>
</template>

<script>
// import { calculateCost } from "@/utils/calculator";
import { mapMutations } from "vuex";
import { localizeUrl } from "@/utils/localizeUrl";
import { BACKEND_URL } from "./utils/config";

export default {
  data: () => {
    return {
      toggle: false
    };
  },
  computed: {
    calcData() {
      return this.$store.state.data;
    }
  },
  watch: {
    calcData: {
      deep: true,
      handler() {
        // this.updateCost(calculateCost(this.calcData).totalCost);
      }
    }
  },
  mounted() {
    console.log(BACKEND_URL);
    this.updateLang();
    // this.updateCost(calculateCost(this.calcData).totalCost);
  },
  beforeUpdate() {
    this.updateLang();
  },
  methods: {
    ...mapMutations(["updateCost"]),
    localizeUrl: localizeUrl,
    updateLang() {
      // Set locale based on url
      let path = this.$route.path;
      let lang = "en";
      if (path === "/de" || path.endsWith("-de")) {
        lang = "de";
      }
      this.$i18n.locale = lang;
    }
  }
};
</script>

<style lang="scss">
@import "common/_variables.scss";

.nav-wrapper {
  border-bottom: 1px solid #d8d8d8;
  display: flex;
  flex-direction: column;
}

.nav {
  display: flex;
  color: $color-black;
  max-width: 1130px;
  align-self: center;
  width: 100%;
  align-items: stretch;
}
.logo-image {
  height: 20px;
  padding: 16px 0 14px 0;
}
.nav-link {
  margin-right: 8px;
  border-bottom: 2px solid white;
}
.nav-link:hover {
  border-bottom: 2px solid $color-primary;
}
.nav-link-text {
  cursor: pointer;
}
.nav-items {
  display: flex;
  align-self: stretch;
  align-items: stretch;
}
.nav-items-right {
  margin-left: auto;
  .nav-link {
    margin-left: 60px;
    padding-top: 14px;
    align-self: stretch;
  }
}
.nav-toggle {
  font-size: 1.2rem;
  display: none;
}

@media only screen and (max-width: 768px) {
  .nav-items,
  .nav {
    flex-direction: column;
  }
  .nav-items {
    display: none;
    padding-top: 20px;
  }
  .nav-items-right {
    margin-left: 0;
  }
  .nav-toggle-show {
    display: flex;
  }
  .nav-toggle {
    align-self: flex-end;
    display: initial;
    position: absolute;
    cursor: pointer;
  }
}

a {
  color: black !important;
}

body {
  overflow-x: hidden !important;
}

#app {
  font-family: $font-primary;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  font-weight: 400;
  display: flex;
  flex-direction: column;
}

.font {
  font-family: $font-primary;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
h1 {
  font-family: $font-primary;
  font-size: 32px;
  font-weight: 800;
  color: #191919;
  padding: 15px 0;
  margin: 0;
}
h4 {
  margin: 0;
  color: #505050;
}
p {
  font-family: $font-secondary;
  font-size: 0.9rem;
  color: #505050;
  line-height: 1.5;
}
a {
  color: $color-primary;
  text-decoration: none;
}

.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
